module.exports = __webpack_public_path__ + "static/media/26UNRWA22.9b6b480d.jpg";